import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getRtaOffices,
  rtaOfficesListSuccessful,
  rtaOfficesAddSuccessful,
  isModelVisible,
} from "./rtaOfficesSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getRtaOffice({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/rtaoffices/", params);
    yield put(rtaOfficesListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* CreateRtaOffice({ payload }) {
  console.log("CreateRtaOffice saga called with payload:", payload);
  try {
    const response = yield call(postAdd, "/masters/rtaoffices/", payload);
    console.log("POST response:", response);
    
    if (response.status === 201) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              RTA Office Added Successfully!
            </p>
          </div>
        ),
      });
      yield put(getRtaOffices({ page: 1, search: "", page_size: 10 }));
      yield put(isModelVisible(false));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Unable to add RTA Office. Please try again!
            </p>
          </div>
        ),
      });
    }
    yield put(rtaOfficesAddSuccessful(null));
  } catch (error) {
    console.log("Error in CreateRtaOffice saga:", error);
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* UpdateRtaOffice({ payload }) {
  console.log("UpdateRtaOffice saga called with payload:", payload);
  try {
    const response = yield call(
      postEdit,
      "/masters/rtaoffices/" + payload.id,
      payload
    );
    console.log("PUT response:", response);
    
    if (response.status === 200) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              RTA Office Updated Successfully!
            </p>
          </div>
        ),
      });
      yield put(getRtaOffices({ page: 1, search: "", page_size: 10 }));
      yield put(isModelVisible(false));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Unable to edit RTA Office. Please try again!
            </p>
          </div>
        ),
      });
    }
    yield put(rtaOfficesAddSuccessful(null));
  } catch (error) {
    console.log("Error in UpdateRtaOffice saga:", error);
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteRtaOffices({ payload }) {
  var rtaOfficeId = payload;
  try {
    const response = yield call(postDelete, "/masters/rtaoffices/" + rtaOfficeId);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              RTA Office has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getRtaOffices({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! RTA Office has not been deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchGetRtaOffices() {
  yield takeEvery("rtaOffices/getRtaOffices", getRtaOffice);
}

export function* watchRtaOfficesCreate() {
  yield takeEvery("rtaOffices/rtaOfficesCreate", CreateRtaOffice);
}

export function* watchRtaOfficesUpdate() {
  yield takeEvery("rtaOffices/rtaOfficesUpdate", UpdateRtaOffice);
}

export function* watchRtaOfficesDelete() {
  yield takeEvery("rtaOffices/rtaOfficesDelete", DeleteRtaOffices);
}

function* RtaOfficesSaga() {
  yield all([
    fork(watchGetRtaOffices),
    fork(watchRtaOfficesCreate),
    fork(watchRtaOfficesUpdate),
    fork(watchRtaOfficesDelete)
  ]);
}

export default RtaOfficesSaga;
